import { useEffect, useState } from 'react';

import { apiUser } from '../../api/apiUser.api';
import useAxiosPrivate from '../../hooks/useAxiosPrivate';

import DotSpinner from '../shared/DotSpinner';
import { ProfileActionButtons } from './ProfileActionButtons';
import { ProfilePhotos } from './ProfilePhotos';
import { ProfileInformation } from './ProfileInformation';
import { GiftListProfile } from '../gifts/GiftListProfile';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useSubscription } from '../../hooks/useSubscription';

export function ProfileExample({ userId, actionButtons, showActionButtons = true, className = '' }) {
  const auth = useSelector((state) => state.auth);
  const { isActiveSubscription } = useSubscription();
  const photosVisibleCount = isActiveSubscription ? Infinity : Math.max(1, auth?.data?.photos.length || 0);

  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();

  const [userData, setUserData] = useState();

  useEffect(() => {
    apiUser
      .fetchUserById(axiosPrivate, userId)
      .then(setUserData)
      .catch((err) => {
        toast.error('Пользователь не найден');
        console.error(err);
        navigate(-1);
      });
  }, [userId]);

  if (!userData)
    return (
      <div className="flex items-center justify-center min-h-[100vh]">
        <DotSpinner />
      </div>
    );

  return (
    <>
      {showActionButtons && <ProfileActionButtons userId={userId} />}
      <div className={`relative w-full rounded-[16px] overflow-hidden p-4 ${className}`}>
        <ProfilePhotos visibleCount={photosVisibleCount} photos={userData?.photos}>{actionButtons && actionButtons}</ProfilePhotos>

        <div className="p-6 bg-[#010D0D] rounded-b-[16px]">
          <ProfileInformation
            name={userData?.name}
            birthDay={userData?.birthDay}
            city={userData?.city}
            country={userData?.country}
            purpose={userData?.purpose}
            audioMessage={userData?.audioMessage}
            interests={userData?.interests}
          />
          <GiftListProfile userId={userId} />
        </div>
      </div>
    </>
  );
}
